import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const staffCanUsePos = (user) => {
  if (user?.canUsePos !== undefined) return !!user.canUsePos;
  if (user?.permissions?.canUsePos !== undefined) return !!user.permissions.canUsePos;
  return true;
};

const PosRoute = () => {
  const { role, user } = useAuth();

  if (role === 'SALON_MANAGER' || role === 'SUPER_ADMIN') return <Outlet />;

  if (user?.staffRegistrationRejected) {
    return <Navigate to="/staff/registration-rejected" replace />;
  }

  if (user?.staffPendingApproval) {
    return <Navigate to="/staff/pending-approval" replace />;
  }

  if (role === 'SALON_STAFF' && staffCanUsePos(user)) return <Outlet />;

  return <Navigate to="/403" replace />;
};

export default PosRoute;
